import { ExternalSignerInfoLabelFragment } from "gql/graphql";
import { Email } from "@/shared/data-display/email";

export function ExternalSignerInfoLabel({
  externalExternalSignerInfo,
}: {
  externalExternalSignerInfo: ExternalSignerInfoLabelFragment;
}) {
  return (
    <div className={"grid gap-y-1"}>
      <Email email={externalExternalSignerInfo.email} />
    </div>
  );
}
